// extracted by mini-css-extract-plugin
var _1 = "CommentThreadCompactAvatarStack-module__accent--zKtwK";
var _2 = "CommentThreadCompactAvatarStack-module__animateUploadProgressBarWidth--qQmfm";
var _3 = "CommentThreadCompactAvatarStack-module__animatedBackground--K0o8Q";
var _4 = "CommentThreadCompactAvatarStack-module__avatarContainer--HiIsE";
var _5 = "CommentThreadCompactAvatarStack-module__container--i9_zy";
var _6 = "CommentThreadCompactAvatarStack-module__counter--VJeNU";
var _7 = "CommentThreadCompactAvatarStack-module__success--TVYX0";
export { _1 as "accent", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "avatarContainer", _5 as "container", _6 as "counter", _7 as "success" }
